import React, {Component} from "react";
import {message, Table} from "antd";
import {orderBy} from 'lodash';

import DataTable from "./DataTable";
import Loader from "../../../Common/Component/Loader";

class Proposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      listPagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
      activePagination: '15',
      list: {},
      search_value: props.search_value,
      filterData: {}
    }
  }

  componentDidMount = () => {
    const {activePagination, search_value} = this.state;
    this.setState({loader: true});
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    this.setState({logged_in_user_role}, () => {
      const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
      this.props.getAllQuote({
        limit: activePagination,
        offset: 0,
        q: search_value,
        field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
      }) // get list of proposal
    })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {search_value, activePagination, listPagination, filterData} = this.state;
    // message.destroy();
    this.setState({loader: false});

    // get customer list
    if (Object.keys(nextProps?.CommercialProposal?.list).length > 0 && nextProps?.CommercialProposal?.list !== this.state?.list) {
      this.setState({list: nextProps?.CommercialProposal?.list});
    }

    // get filter conditions
    if (Object.keys(nextProps?.filterData).length > 0 && JSON.stringify(nextProps?.filterData) !== JSON.stringify(filterData)) {
      this.setState({filterData: nextProps?.filterData}, () => this.onFilter());
    }

    // search value
    if (nextProps?.search_value !== search_value && (nextProps?.search_value?.length >= 3 || nextProps?.search_value?.length === 0)) {
      this.setState({search_value: nextProps?.search_value, listPagination: {...listPagination, current: 1}}, () => {
        setTimeout(() => {
          const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
          this.props.getAllQuote({
            offset: 0,
            limit: activePagination,
            ordering: '',
            q: nextProps?.search_value,
            // is_looking_for_proposal: true,
            field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
          });
        }, 1000)
      })
    }

  }

  // get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;

    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const franchise_uuid = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    return {is_franchise_owner, franchise_uuid: franchise_uuid?.[0]}
  }

  // on customer filter
  onFilter = () => {
    const {filterData, activePagination, search_value, listPagination} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
    this.setState({loader: true, listPagination: {...listPagination, current: 1}})
    const obj = {
      // is_looking_for_proposal: true,
      offset: 0,
      limit: activePagination,
      ordering: '',
      q: search_value,
      field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
    };

    (filterData?.franchise && filterData?.franchise !== 'all') &&
    Object.assign(obj, {field_office__uuid__in: filterData?.franchise});
    this.props.getAllQuote(obj) // get list of proposal
  }

  //Table Order and Pagination
  onTableChange = (pagination, filters, sorter) => {
    const {listPagination, activePagination, search_value, filterData} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
    let ordering = ''
    Object.assign(listPagination, { current: pagination.current });

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }
    Object.assign(listPagination, { ordering });

    this.setState({
      listPagination,
      loader: true
    });

    let obj = {/*is_looking_for_proposal: true,*/
      offset: ((pagination.current - 1) * activePagination),
      limit: pagination?.pageSize,
      ordering,
      q: search_value,
      field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
    }

    if (filterData?.franchise && filterData?.franchise !== 'all') {
      Object.assign(obj, {field_office__uuid__in: filterData?.franchise});
    }

    this.props.getAllQuote(obj);

  }

  // page size change
  setPageLimit = (value) => {
    const {listPagination} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
    Object.assign(listPagination, { current: 1, pageSize: value, ordering: '' });

    this.setState({activePagination: value, listPagination});
    this.props.getAllQuote({ 
      offset: 0,
      limit: value,
      ordering: '',
      field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
    });
  };

  // on customer list row
  onListRow = (record) => {
    return {
      onClick: () => {
        console.log(record)
        this.props.history.push(`/commercial/proposal-detail`, { query: { 'id': record?.uuid, detail: record } })
      }
    }
  }

  render() {
    const {list, listPagination, activePagination, loader} = this.state;
    return (
      <div>
        {loader && <Loader />}
        <Table
          rowKey={record => record?.uuid}
          dataSource={listPagination?.ordering ? list?.results : orderBy(list?.results, 'created_at', 'desc')}
          pagination={{...listPagination, total: list?.count}}
          columns={DataTable.proposalColumns()}
          onChange={this.onTableChange}
          onRow={this.onListRow}
          className="customer-list"
        />
        {list?.results?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setPageLimit('15') }}
                className={activePagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={activePagination === '30' ? 'active' : ''}
                onClick={() => { this.setPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={activePagination === '60' ? 'active' : ''}
                onClick={() => { this.setPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  }
}

export default Proposal
